export default __webpack_public_path__ + "static/media/dot_Roadmap.dc903c65.svg";